module.exports = __webpack_public_path__ + "img/bag.1add9014.svg";